import { IGamesCategoryPrepared } from '../../types';

export interface IWidget {
  type: string;
  numberOfCategoriesBefore: number;
}

type CategoriesWithWidgetsType = IGamesCategoryPrepared | IWidget;

export const mergeCasinoCategoriesAndWidgets = (
  categories: IGamesCategoryPrepared[],
  widgets: IWidget[]
): CategoriesWithWidgetsType[] => {
  let categoryIndex = 0;
  const newCombinedArray: CategoriesWithWidgetsType[] = [];

  widgets?.forEach((widget) => {
    const { numberOfCategoriesBefore } = widget;
    newCombinedArray.push(
      ...categories.slice(
        categoryIndex,
        categoryIndex + numberOfCategoriesBefore
      )
    );
    newCombinedArray.push(widget);
    categoryIndex += numberOfCategoriesBefore;
  });

  newCombinedArray.push(...categories.slice(categoryIndex));
  return newCombinedArray;
};
